import { z } from 'zod';

// ==============================================================================
// TIMEZONE SCHEMAS - Simple enum pattern like LanguageLevel
// ==============================================================================

export enum Timezone {
  UTC = 'UTC',
  NEW_YORK = 'America/New_York',
  LOS_ANGELES = 'America/Los_Angeles',
  CHICAGO = 'America/Chicago',
  DENVER = 'America/Denver',
  LONDON = 'Europe/London',
  PARIS = 'Europe/Paris',
  BERLIN = 'Europe/Berlin',
  MADRID = 'Europe/Madrid',
  ROME = 'Europe/Rome',
  MOSCOW = 'Europe/Moscow',
  DUBAI = 'Asia/Dubai',
  TOKYO = 'Asia/Tokyo',
  SHANGHAI = 'Asia/Shanghai',
  SYDNEY = 'Australia/Sydney',
  SAO_PAULO = 'America/Sao_Paulo',
  MEXICO_CITY = 'America/Mexico_City',
  TORONTO = 'America/Toronto',
}

// Zod schema from TypeScript enum
export const TimezoneSchema = z.nativeEnum(Timezone);

// Type export
export type TimezoneType = z.infer<typeof TimezoneSchema>;
